import getObjectValue from 'libs/getObjectValue';
import reduxStore from 'redux/store'
import DealingsService from 'services/DealingsService';
import {setSaveStatusClosed, setSaveStatusLoading} from 'redux/actions';
import setObjectValue from 'libs/setObjectValue';
import _ from 'lodash';
import stageValues from '../constants/stage.values';
import {CONDITION_TYPE_OTHER, CONDITIONS_LABEL, CONDITIONS_LABEL_PZP_2021} from 'components/popup/newCondition/constants/condition.values';
import {CRYTERIUM_TYPE, CRYTERIUM_TYPE_LABEL} from 'components/popup/newCriteria/constants/criterium.type';
import {getDemandPZPType} from "libs/getDemandStatus";
import PZPType from "constants/PZPType";

const doElement = (critArray, editedCriterion, originalCriterion, stageName, dealingId, doDelete) => {
    const _formikCritArrayCopy = _.cloneDeep(critArray);
    const _editedCritCopy = _.cloneDeep(editedCriterion);
    const demandPzpType = getDemandPZPType();
    const conditionLabels = PZPType.PZP_2021 === demandPzpType ? CONDITIONS_LABEL_PZP_2021 : CONDITIONS_LABEL;
    if (!originalCriterion) {
        //dodanie nowego kryterium, więc nie mamy "zmienianego"
        originalCriterion = _editedCritCopy;
    }

    let oldFieldIndex;

    switch (stageName) {
        case stageValues.CONDITIONS:
            oldFieldIndex = _formikCritArrayCopy.findIndex(x => {
                if (originalCriterion.type === CONDITION_TYPE_OTHER) {
                    if (x.type === CONDITION_TYPE_OTHER) {
                        return originalCriterion.otherName === x.otherName;
                    } else {
                        return originalCriterion.otherName === conditionLabels[x.type];
                    }
                } else {
                    if (x.type === CONDITION_TYPE_OTHER) {
                        return conditionLabels[originalCriterion.type] === x.otherName
                    } else {
                        return originalCriterion.type === x.type
                    }
                }
            })
            break;
        case stageValues.CRITERIONS:
            oldFieldIndex = _formikCritArrayCopy.findIndex(x => {
                if (originalCriterion.type === CRYTERIUM_TYPE.OTHER || originalCriterion.type === CRYTERIUM_TYPE.PRICE) {
                    if (x.type === CRYTERIUM_TYPE.OTHER || x.type === CRYTERIUM_TYPE.PRICE) {
                        return originalCriterion.otherName === x.otherName;
                    } else {
                        return originalCriterion.otherName === CRYTERIUM_TYPE_LABEL[x.type];
                    }
                } else {
                    if (x.type === CRYTERIUM_TYPE.OTHER || x.type === CRYTERIUM_TYPE.PRICE) {
                        return CRYTERIUM_TYPE_LABEL[originalCriterion.type] === x.otherName;
                    } else {
                        return originalCriterion.type === x.type
                    }
                }
            });

            break;
        case stageValues.PARAMETERS:
        case stageValues.ITEM_PARAMETERS:
            oldFieldIndex = _formikCritArrayCopy.findIndex(x => x.name === originalCriterion.name);
            break;
        default:
            break;
    }

    if (doDelete) {
        if (oldFieldIndex >= 0) {
            _formikCritArrayCopy.splice(oldFieldIndex, 1);
        }
    } else {
        if (oldFieldIndex < 0) {
            _formikCritArrayCopy.push({
                ..._editedCritCopy,
                dealingId,
                identity: -_formikCritArrayCopy.length - 1,
            })
        } else {
            const oldField = _formikCritArrayCopy[oldFieldIndex];
            _formikCritArrayCopy[oldFieldIndex] = {
                ..._editedCritCopy,
                identity: oldField.identity,
            }
        }
    }

    if (stageName === stageValues.CRITERIONS) {
        //aktualizacja wagi ceny
        const priceIndex = _formikCritArrayCopy.findIndex(x => x.type === CRYTERIUM_TYPE.PRICE);

        let sum = _formikCritArrayCopy.reduce((prev, cur) => {
            if (cur.type !== CRYTERIUM_TYPE.PRICE) {
                return prev + parseFloat(cur.weight);
            }
            return prev;
        }, 0);
        sum = parseFloat(sum.toFixed(2));

        const priceWeight = (100 - sum) < 0 ? 0 : 100 - sum;

        _formikCritArrayCopy[priceIndex].weight = priceWeight;
    }

    return _formikCritArrayCopy;
}

const hasElement = (dealing, crit, stageName) => {
    const objectValue = getObjectValue(`stages.0.${stageName}`, dealing, []);
    let oldFieldIndex = 10;

    const demandPzpType = getDemandPZPType();
    const conditionLabels = PZPType.PZP_2021 === demandPzpType ? CONDITIONS_LABEL_PZP_2021 : CONDITIONS_LABEL;

    switch (stageName) {
        case stageValues.CONDITIONS:
            oldFieldIndex = objectValue.findIndex(x => {
                if (crit.type === CONDITION_TYPE_OTHER) {
                    if (x.type === CONDITION_TYPE_OTHER) {
                        return crit.otherName === x.otherName;
                    }
                    return crit.otherName === conditionLabels[x.type];
                }
                return crit.type === x.type
            })
            break;
        case stageValues.CRITERIONS:
            oldFieldIndex = objectValue.findIndex(x => {
                if (crit.type === CRYTERIUM_TYPE.OTHER) {
                    if (x.type === CRYTERIUM_TYPE.OTHER) {
                        return crit.otherName === x.otherName;
                    }
                    return crit.otherName === CRYTERIUM_TYPE_LABEL[x.type];
                }
                return crit.type === x.type
            })
            break;
        case stageValues.PARAMETERS:
        case stageValues.ITEM_PARAMETERS:
            oldFieldIndex = objectValue.findIndex(x => x.name === crit.name);
            break;
        default:
            break;
    }
    if (oldFieldIndex >= 0) {
        return true;
    } else {
        return false;
    }
}


export const findTemporaryDealingIds = (dealingsContains, allItems, id, crit) => {
    const splitId = id.split('.');
    splitId.shift();// remove index
    const stageName = splitId[splitId.length - 1];

    const remoteDealingIds = dealingsContains.map(x => x.identity);

    const dealingIds = [];
    allItems.forEach((curDeal, i) => {
        if (remoteDealingIds.indexOf(curDeal.identity) > -1 || hasElement(curDeal, crit, stageName)) {
            dealingIds.push(curDeal.identity);
        }
    });
    return dealingIds;

}

export const filterByCurrentLoadedDealings = (dealingsContains, allItems, id, crit) => {
    const splitId = id.split('.');
    splitId.shift();// remove index
    const stageName = splitId[splitId.length - 1];

    allItems.forEach((curDeal, i) => {
        if (curDeal._touched) {
            const found = dealingsContains.findIndex(el => el.identity === curDeal.identity);
            if (found !== -1) {
                if (!hasElement(curDeal, crit, stageName)) {
                    dealingsContains.splice(found, 1);
                }
            }
        }
    });

}


export const removeElementsfromParts = (formikProps, id, dealings, criterion, demandId) => {
    doElementsManipulation(formikProps, id, dealings, criterion, null, demandId, true);
}

export const addElementsToParts = (formikProps, id, dealings, criterion, originalCriterion, demandId) => {
    doElementsManipulation(formikProps, id, dealings, criterion, originalCriterion, demandId, false);
}

const doElementsManipulation = (formikProps, id, dealings, editedCriterion, originalCriterion, demandId, doDelete) => {

    const splitId = id.split('.');
    const rootId = splitId.shift();// remove root
    splitId.shift();// remove index
    const fieldId = splitId.join('.')
    const partsIds = Object.keys(dealings).filter(x => dealings[x]);

    const stageName = splitId[splitId.length - 1];

    (async () => {
        if (partsIds.length < 1) {
            return;
        }
        reduxStore.dispatch(setSaveStatusLoading());

        const {resources} = reduxStore.getState();
        const currentDealingList = getObjectValue(rootId, formikProps.values)

        const missingArray = [];
        for (let i = 0; i < partsIds.length; i++) {
            const dealingId = partsIds[i];
            const dealing = resources.dealing ? resources.dealing[dealingId] : undefined;
            if (!dealing) {
                missingArray.push(dealingId)
            }
        }
        let newDownloaded = {};
        if (missingArray.length > 0) {
            newDownloaded = await DealingsService.getFullList(demandId, missingArray);
        }


        const processedDealings = {};
        for (let i = 0; i < partsIds.length; i++) {
            const dealingId = partsIds[i];
            const dealing = resources.dealing ? resources.dealing[dealingId] : undefined;
            const delaingIndex = currentDealingList.findIndex(x => '' + x.identity === dealingId)
            let currentDealing;
            if (dealing) {
                // dealing exist
                currentDealing = _.cloneDeep(currentDealingList[delaingIndex]);
            } else {
                // need get dealing
                //currentDealing = await DealingsService.get(demandId, dealingId);
                currentDealing = newDownloaded[dealingId]
            }

            let critArray = getObjectValue(fieldId, currentDealing)
            critArray = doElement(critArray, editedCriterion, originalCriterion, stageName, dealingId, doDelete)
            currentDealing._touched = true;
            setObjectValue(fieldId, currentDealing, critArray)
            // const partId = `${rootId}.${delaingIndex}`
            // formikProps.setFieldValue(partId, currentDealing);
            processedDealings[currentDealing.identity] = currentDealing;
        }
        const newDealingList = currentDealingList.map((el) => {
            const dealingId = el.identity;
            const processed = processedDealings[dealingId];
            if (Boolean(processed)) {
                return processed
            } else {
                return el;
            }
        });
        formikProps.setFieldValue(rootId, newDealingList);
        reduxStore.dispatch(setSaveStatusClosed());
    })();
}